import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

interface Row {
  name?: string;
  [k: string]: any;
}
interface Props {
  rows: Row[];
  modelValue: any;
  selectedField: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByFilter',
  props: {
    rows: null,
    modelValue: null,
    selectedField: null
  },
  emits: ["update:modelValue", "update:selectedField"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", v: any): void;
  (e: "update:selectedField", v: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  rows: Row[];
  modelValue: any;
  selectedField: string;
}




const names = computed<string[]>(() => {
  return (props.rows || []).map(r => {
    return r.name;
  });
});

const value = computed<any>({
  get: () => props.modelValue,
  set: v => emit("update:modelValue", v)
});

const selectedFieldProxy = computed<string>({
  get: () => props.selectedField || names.value[0],
  set: v => emit("update:selectedField", v)
});

return { __sfc: true,props, emit, names, value, selectedFieldProxy }
}

})